import { render, staticRenderFns } from "./course_file_manage.vue?vue&type=template&id=d1f443fe&scoped=true&"
import script from "./course_file_manage.vue?vue&type=script&lang=js&"
export * from "./course_file_manage.vue?vue&type=script&lang=js&"
import style0 from "./course_file_manage.vue?vue&type=style&index=0&id=d1f443fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f443fe",
  null
  
)

export default component.exports